import React from "react";
import { Button, Modal, Form, notification, Select, Radio } from "antd";
import { defaultFormLayout } from "../../common/Utils";
import { ApolloError } from "apollo-boost";
import { observer } from "mobx-react";
import { familyStore } from "../../store/family/FamilyStore";
import { FamilyAddNewChild } from "./FamilyAddNewChild";
import { FamilyAddExistingChild } from "./FamilyAddExistingChild";
import { Api } from "../../common/Api";

export const FamilyAddChild = observer(({ family, onChange }) => {
  const { addChild } = familyStore;
  const [form] = Form.useForm();

  const add = (childId) => {
    form.validateFields().then((values) => {
      console.log("values", values);
      Api.family
        .familyAddExistingChild(childId, values.parentIds)
        .then((res) => {
          notification.success({
            message: `Child created.`,
          });
          addChild.store.loadData();
          addChild.close();
        })
        .catch((err: ApolloError) => {});
    });
  };

  const save = () => {
    form.validateFields().then((values) => {
      console.log("values", values);

      Api.family
        .familyAddNewChild(values)
        .then((res) => {
          notification.success({
            message: `Child created.`,
          });
          addChild.store.loadData();
          addChild.close();
        })
        .catch((err: ApolloError) => {
          if (err.graphQLErrors) {
            try {
              const json = JSON.parse(err.graphQLErrors[0].message);
              if (json.msg === "Duplicate email") {
                form.setFields([
                  {
                    name: "email",
                    errors: [
                      `User with the same email address was found: ${json.info} Division. If the user has moved, please contact the Managing Director to move the record to your division. Otherwise, please double check the email.`,
                    ],
                  },
                ]);
              }
            } catch {
              notification.error({
                message: err.graphQLErrors[0].message,
              });
            }
          }
        });
    });
  };

  const onTab = (e) => {
    addChild.isNew = e.target.value;
  };

  const onShow = () => {
    addChild.show();
    form.resetFields();
  };

  return (
    <>
      <Button onClick={() => onShow()}>Add Child</Button>
      {addChild.showDlg && (
        <Modal
          title={`Add a Child`}
          visible={addChild.showDlg}
          centered
          onOk={save}
          // confirmLoading={saving}
          onCancel={() => addChild.close()}
          footer={null}
          maskClosable={false}
        >
          <Form form={form} {...defaultFormLayout} initialValues={{ parentIds: [] }}>
            <Form.Item name="parentIds" label="Parents" rules={[{ required: true, message: "Please select parents" }]}>
              <Select mode="multiple" style={{ width: "100%" }} placeholder="Please select">
                {family?.parents.map((p) => (
                  <Select.Option key={p.user.id} value={p.user.id}>
                    {p.user.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item wrapperCol={{ span: 16, offset: 8 }}>
              <Radio.Group value={addChild.isNew} onChange={(e) => onTab(e)}>
                <Radio.Button value={false}>Find Existing</Radio.Button>
                <Radio.Button value={true}>Create New</Radio.Button>
              </Radio.Group>
            </Form.Item>
            {addChild.isNew && <FamilyAddNewChild onNew={() => save()} />}
          </Form>
          {!addChild.isNew && <FamilyAddExistingChild onAdd={(id) => add(id)} />}
        </Modal>
      )}
    </>
  );
});
